'use es6';

import PropTypes from 'prop-types';
import ServiceAvailabilityStatusPropType from './ServiceAvailabilityStatusPropType';
const AvailabilityStatusPropType = PropTypes.shape({
  zuora: ServiceAvailabilityStatusPropType.isRequired
});
export default AvailabilityStatusPropType;